import React, { useContext, useEffect, useState } from "react";
import { PaymentMethodsContext } from "../../context/PaymentMethodsContext";
import { PurchasesContext } from "../../context/PurchasesContext";
import Switch from "react-switch";
import useTranslations from "../../hooks/useTranslations";

const cancelledStatus = ["cancelled", "revoked"];

const EditPurchaseForm = ({ handleCancel }) => {
    const [originalStatus, setOriginalStatus] = useState(null);
    const { purchase, updatePurchase, setPropertyPurchase } =
        useContext(PurchasesContext);

    const { purchases: purchasesTranslation } = useTranslations()

    const { payment_methods, getPaymentMethods } = useContext(PaymentMethodsContext);

    useEffect(() => {
        setOriginalStatus(purchase.status);
        getPaymentMethods();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        updatePurchase(purchase);
    };

    const renderWarning = () => {
        if (purchase.status === "cancelled" && purchase.status !== originalStatus) {
            return (
                <p>
                    {purchasesTranslation.cancelMessage}
                </p>
            );
        }
        if (purchase.status === "cancelled" && purchase.status !== originalStatus) {
            return (
                <p>
                    {purchasesTranslation.revokeMessage}
                </p>
            );
        }
        if (
            (purchase.status === "active" || purchase.status === "completed") &&
            originalStatus !== purchase.status
        ) {
            return (
                <p>
                    {purchasesTranslation.activateMessage}
                </p>
            );
        }
    };

    const renderButton = () => {
        if (
            cancelledStatus.includes(purchase.status) &&
            !cancelledStatus.includes(originalStatus)
        ) {
            return (
                <div className="row">
                    <div className="col-6">
                        <button
                            type="button"
                            onClick={handleCancel}
                            className="btn w-100 text-muted"
                        >
                            {purchasesTranslation.expirationDays}
                        </button>
                    </div>
                    <div className="col-6">
                        <input
                            type="submit"
                            className="btn btn-danger"
                            value="Actualizar Compra"
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className="row">
                <div className="col-6">
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="btn w-100 text-muted"
                    >
                        {purchasesTranslation.cancel}
                    </button>
                </div>
                <div className="col-6">
                    <input
                        type="submit"
                        className="btn w-100 btn-primary"
                        value={purchasesTranslation.savePurchase}
                    />
                </div>
            </div>
        );
    };

    const renderPaymentMethods = () => {
        if (Array.isArray(payment_methods)) {
            return payment_methods.map((payment_method) => (
                <option
                    key={payment_method.payment_method_id}
                    value={payment_method.payment_method_id}
                >
                    {payment_method.name}
                </option>
            ));
        }
    };

    const renderReason = () => {
        if (purchase.status === "cancelled" && purchase.status !== originalStatus) {
            return (
                <div>
                    <label>Razón de Cancelación</label>
                    <input
                        type="text"
                        className="form-control mb-3"
                        value={purchase.cancel_reason}
                        onChange={(e) =>
                            setPropertyPurchase("cancel_reason", e.target.value)
                        }
                    />
                </div>
            );
        }
    };

    return (
        <div className="container-fluid px-0">
            <form onSubmit={handleSubmit}>
                <label>{purchasesTranslation.expirationDays}</label>
                <input
                    type="number"
                    className="form-control mb-3"
                    value={purchase?.expiration_days}
                    onChange={(e) =>
                        setPropertyPurchase("expiration_days", e.target.value)
                    }
                />
                <label>{purchasesTranslation.totalAmount}</label>
                <input
                    type="number"
                    className="form-control mb-3"
                    value={purchase.amount}
                    onChange={(e) => setPropertyPurchase("amount", e.target.value)}
                />

                <label className="d-block">{purchasesTranslation.isGift}</label>
                <Switch
                    className="d-block mt-1 mb-3"
                    checked={purchase.is_gift || purchase.amount === 0}
                    onChange={(checked) => setPropertyPurchase("is_gift", checked)}
                />
                {!purchase.is_gift && (
                    <div>
                        <label className="d-block">{purchasesTranslation.paymentMethod}</label>
                        <select
                            className="form-control mb-3"
                            value={purchase.payment_method_id}
                            onChange={(e) =>
                                setPropertyPurchase("payment_method_id", e.target.value)
                            }
                        >
                            {renderPaymentMethods()}
                        </select>
                    </div>
                )}
                <label>{purchasesTranslation.status}</label>
                <select
                    className="form-control mb-3"
                    value={purchase.status}
                    onChange={(e) => setPropertyPurchase("status", e.target.value)}
                >
                    {!cancelledStatus.includes(originalStatus) && (
                        <>
                            <option value="active">{purchasesTranslation.active}</option>
                            <option value="completed">{purchasesTranslation.completed}</option>
                            <option value="pending">{purchasesTranslation.pending}</option>
                        </>
                    )}
                    <option value="cancelled">{purchasesTranslation.cancelled}</option>
                    <option value="revoked">{purchasesTranslation.revoked}</option>
                </select>
                {renderReason()}
                {renderWarning()}
                {renderButton()}
            </form>
        </div>
    );
};

export default EditPurchaseForm;
